import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { VictoryLegend, VictoryPie } from "victory";

const PieChart = ({ data }) => {
	const { t } = useTranslation();
	const totalSold = data.reduce((accumulator, currentValue) => {
		return accumulator + currentValue.sold;
	}, 0);

	const filteredData = data.filter((item) => item.sold > 0);

	return (
        <Box>
            <Box sx={{ background: "#000", color: "#fff", p: "6px 14px" }}>
				{t("sale_label")} &mdash;{" "}
				<span style={{ textTransform: "lowercase" }}>{t("channels")}</span>
			</Box>
            {filteredData.length ? (
				<Box>
					<svg width={600} height={400}>
						<VictoryLegend
							gutter={20}
							x={20}
							y={40}
							standalone={false}
							colorScale={[
								"#4472c4",
								"#ed7d31",
								"#a5a5a5",
								"#ffc000",
								"#5b9bd5",
							]}
							data={filteredData.map((item) => ({
								name:
									item.channel.charAt(0).toUpperCase() + item.channel.slice(1),
							}))}
						/>
						<VictoryPie
							standalone={false}
							width={700}
							height={400}
							padding={{
								left: 100,
								bottom: 20,
								top: 20,
							}}
							colorScale={[
								"#4472c4",
								"#ed7d31",
								"#a5a5a5",
								"#ffc000",
								"#5b9bd5",
							]}
							x="channel"
							y="sold"
							labelRadius={100}
							labels={({ datum }) => `${datum.channel} ${datum.sold}`}
							labelComponent={<CustomLabel total={totalSold} />}
							data={filteredData}
						/>
					</svg>
				</Box>
			) : (
				// <Box>
				// 	<svg width={600} height={400} style={{ border: "1px solid #ccc" }}>
				// 		<VictoryLegend
				// 			standalone={false}
				// 			colorScale={["tomato", "orange", "gold"]}
				// 			x={20}
				// 			y={40}
				// 			gutter={20}
				// 			data={legendData}
				// 		/>
				// 		<VictoryPie
				// 			standalone={false}
				// 			width={300}
				// 			height={200}
				// 			padding={{
				// 				left: 100,
				// 				bottom: 20,
				// 				top: 20,
				// 			}}
				// 			colorScale={["tomato", "orange", "gold"]}
				// 			data={data}
				// 			labels={() => null}
				// 		/>
				// 	</svg>
				// </Box>
				(<Box sx={{ textAlign: "center", mt: "20px;" }}>{t("no_sales")}</Box>)
			)}
        </Box>
    );
};

export default PieChart;

const CustomLabel = (props) => {
	const { x, y, datum } = props;
	return (
		<text x={x} y={y} fontSize={14} textAnchor="middle" fill="#404040">
			<tspan x={x} dy="-0.5em">
				{datum.sold}
			</tspan>
			<tspan x={x} dy="1.2em">
				{datum.channel.toUpperCase()}
			</tspan>
			<tspan x={x} dy="1.2em">
				{((datum.sold * 100) / props.total).toFixed(2)}%
			</tspan>
		</text>
	);
};
